// extracted by mini-css-extract-plugin
export default {"form":"prfile-use-form_form__gKdlK"};